import { ChangeDetectionStrategy, Component, Injector, OnInit } from "@angular/core";
import { FeatureName } from "@common/ADAPT.Common.Model/embed/feature-name.enum";
import { Team } from "@common/ADAPT.Common.Model/organisation/team";
import { emptyIfUndefinedOrNull } from "@common/lib/utilities/rxjs-utilities";
import { BaseRoutedComponent } from "@common/ux/base-routed.component";
import { OrganisationPageRouteBuilder } from "@org-common/lib/route/organisation-page-route-builder";
import { CommonTeamsService } from "@org-common/lib/teams/common-teams.service";
import { IntegratedArchitectureFrameworkAuthService } from "app/features/architecture/integrated-architecture/integrated-architecture-framework-auth.service";
import { Observable, ReplaySubject } from "rxjs";
import { switchMap, tap } from "rxjs/operators";

@Component({
    selector: "adapt-team-systems-page",
    standalone: false,
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: "./team-systems-page.component.html",
})
export class TeamSystemsPageComponent extends BaseRoutedComponent implements OnInit {
    public teamId$ = new ReplaySubject<number | undefined>(1);
    public team$: Observable<Team | undefined>;

    public constructor(
        injector: Injector,
        commonTeamsService: CommonTeamsService,
    ) {
        super(injector);

        this.team$ = this.teamId$.pipe(
            emptyIfUndefinedOrNull(),
            switchMap((teamId) => commonTeamsService.getTeamById(teamId)),
            tap((team) => {
                if (team) {
                    this.notifyActivated();
                } else {
                    this.routeService.gotoHome();
                }
            }),
        );
    }

    public async ngOnInit() {
        await this.updateFromPageParams();
        this.navigationEnd.subscribe(() => this.updateFromPageParams());
    }

    private async updateFromPageParams() {
        const teamId = this.getRouteParamInt("teamId");
        this.teamId$.next(teamId);
    }
}

export const teamSystemsPageRoute = new OrganisationPageRouteBuilder<{ teamId: number }>()
    .usingNgComponent("adapt-team-systems-page", TeamSystemsPageComponent)
    .atOrganisationUrl("/team/:teamId/systems")
    .redirectToThisRouteFromOrganisationUrl("people/teams/:teamId/dashboard?page=system")
    .verifyingFeatures(FeatureName.ArchitectureSystem)
    .verifyingAccess(IntegratedArchitectureFrameworkAuthService.ReadSystem)
    .withTitle("Systems")
    .build();
